
import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Receipt from "../Components/Dashboard/Manage-My-Program/Receipt";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const AuthReceipt = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Receipt /> : <SessionTimeoutRedirect />
}
export default AuthReceipt;


